/* @flow */
import { DEFAULT_COLOR } from 'entities/Group';
import AffiliationStore from 'stores/AffiliationStore';
import DistrictAdminPending from './DistrictAdminPending.jsx';
import GroupView from 'groups/components/GroupView.jsx';
import GroupStore from 'groups/stores/GroupStore';
import JoinConfirmSubscriptionModal from 'join/components/JoinConfirmSubscriptionModal.jsx';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import { mountModal } from 'lib/modal';
import OrganizationStore from 'stores/OrganizationStore';
import React from 'react';
import SchoolAdminPending from './SchoolAdminPending.jsx';
import { needsEmailConf } from 'shapes/Affiliation';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

const viewForOrganization = (organization) => {
  const type = organization.get('type');

  if (type === 'School') {
    return SchoolAdminPending;
  } else if (type === 'District') {
    return DistrictAdminPending;
  }

  throw new Error('Unsupported organization type ' + type);
};

const OrganizationContainer = React.createClass({
  propTypes: {
    location: React.PropTypes.object.isRequired,
    params: React.PropTypes.object.isRequired,
    canAccessAdminConsole: React.PropTypes.bool,
    loading: React.PropTypes.bool,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    linkStateWithStores([AffiliationStore, OrganizationStore, GroupStore]),
  ],

  getInitialState() {
    return {};
  },

  componentWillMount() {
    this.checkForStaffClass();
  },

  componentDidMount() {
    const { query } = this.props.location;
    if (query && 'join' in query) {
      mountModal(<JoinConfirmSubscriptionModal code={query.join} />, this);
    }
  },

  componentDidUpdate() {
    this.checkForStaffClass();
  },

  checkForStaffClass() {
    const organizationId = parseInt(this.props.params.organizationId, 10);
    const organization = OrganizationStore.getOrganization(organizationId);
    const staffClass = GroupStore.getStaffClassForOrg(organizationId);

    if (this.props.loading) {
      return;
    }

    // don't redirect to staff class if it's a district
    // because we want to preserve the current behaviour for
    // user without the admin console ATM.
    const preventStaffClassRedirection = (
      !this.props.canAccessAdminConsole && (
        organization.getType() === 'District' ||
        organization.getType() === 'School'
      )
    );

    if (!staffClass || preventStaffClassRedirection) {
      return;
    }

    const affiliation = AffiliationStore.getAffiliation(organizationId);
    if (staffClass.getType() !== 'district' && affiliation && needsEmailConf(affiliation)) {
      this.context.router.replace(`/classes/${staffClass.getCode()}/verify`);
    }

    this.context.router.replace(`/classes/${staffClass.getCode()}/messages`);
  },

  render() {
    const organizationId = parseInt(this.props.params.organizationId, 10);
    const organization = OrganizationStore.getOrganization(organizationId);
    const affiliation = AffiliationStore.getAffiliation(organizationId);

    const OrgView = viewForOrganization(organization);

    return (
      <GroupView
        accentColor={organization.getAccentColor() || DEFAULT_COLOR}
        group={organization}>
        <OrgView {...{ affiliation, organization }} />
      </GroupView>
    );
  },
});

const withAdminConsoleFeature = graphql(gql`
  query {
    user: me {
      id
      featureFlags {
        web_admin_console
      }
    }
  }`, {
    props: ({ data }) => ({
      canAccessAdminConsole: data.user ? data.user.featureFlags['web_admin_console'] : undefined,
      loading: data.loading,
    }),
  }
);

export default withAdminConsoleFeature(OrganizationContainer);



// WEBPACK FOOTER //
// ./src/organizations/components/OrganizationContainer.jsx